var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roll"},[_c('RollBets'),_c('div',{staticClass:"roll-container"},[_c('RollGame'),_c('RollHistory'),_c('RollControls'),_c('RollUserBets')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }